import 'app/agriculture/FarmMain/TopBar/components/WeatherButton/WeatherButton.scss';
import { ArrowRightIcon, RainIcon, TemperatureIcon } from 'app/agriculture/icons';
import { Tooltip } from '@mui/material';
import { useSelectedFarm } from 'app/agriculture/hooks/useSelectedFarm/useSelectedFarm';
import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { StatDailyRainfall } from 'app/agriculture/components/StatDailyRainfall/StatDailyRainfall';
import { useFarmPath } from 'app/agriculture/router/useFarmPath';
import { useNavigate } from 'react-router-dom';
import { useSnapshot } from 'app/agriculture/queries/snapshots/useSnapshot';
import { useThrottledNow } from 'app/agriculture/AgTimeline/hooks/useThrottledNow';

export function WeatherButton() {
    const farmPath = useFarmPath();
    const navigate = useNavigate();
    const { weatherStation } = useSelectedFarm();
    const now = useThrottledNow();
    const weatherSnapshot = useSnapshot({
        snapshotType: 'Weather',
        cursorTimeOverride: now,
        parentId: weatherStation ?? undefined,
    });

    const handleClick = () => {
        navigate(farmPath('/weather-dashboard'));
    };

    return (
        <Tooltip title={weatherSnapshot?.timestamp.toString() ?? 'No Data'}>
            <div>
                <button
                    className={'WeatherButton'}
                    onClick={handleClick}
                    disabled={weatherStation == null}
                >
                    <StatDisplay
                        id="WeatherButtonTemperatureStat"
                        Icon={(props) => <TemperatureIcon {...props} title="Temperature" />}
                        value={weatherSnapshot?.temperature}
                        emptyStateMessage={'--'}
                        unit={'°C'}
                        decimalPlaces={1}
                    />

                    {weatherStation != null ? (
                        <StatDailyRainfall deviceId={weatherStation} />
                    ) : (
                        <StatDisplay
                            id="WeatherButtonRainfallStat"
                            Icon={(props) => <RainIcon {...props} title={'Rainfall'} />}
                            value={null}
                            emptyStateMessage={'--'}
                            unit={'mm'}
                        />
                    )}
                    <ArrowRightIcon className={'WeatherButton__icon'} />
                </button>
            </div>
        </Tooltip>
    );
}
